import type { SocialLoginProvider } from '~kui/types/auth';

import { IntegrationLoginProvider } from '~kui/types/auth';

const SOCIAL_LOGIN_PROVIDERS: readonly SocialLoginProvider[] = ['google', 'microsoft'];

/**
 * Narrows what `KUIUnifiedAuthSocialButtons` emits back to the social providers, for a consumer
 * that lists no integration buttons and only speaks the social login mutation.
 */
export const isSocialLoginProvider = (provider: SocialLoginProvider | IntegrationLoginProvider): provider is SocialLoginProvider =>
  (SOCIAL_LOGIN_PROVIDERS as readonly string[]).includes(provider);

const INTEGRATION_LOGIN_PROVIDERS: readonly string[] = Object.values(IntegrationLoginProvider);

/**
 * Narrows a login button key from a cluster's `integrationsConfig.loginButtons`, or the slug in
 * the provider login page's path, to the integration providers the frontend knows.
 */
export const isIntegrationLoginProvider = (provider: string): provider is IntegrationLoginProvider =>
  INTEGRATION_LOGIN_PROVIDERS.includes(provider);
